export default __webpack_public_path__ + "static/media/Ch1b.3cd99101.gif";